import { Controller } from "@hotwired/stimulus"
import { TurboBeforeFetchRequestEvent } from "@hotwired/turbo"
import Confirmation from "../confirmation"

export default class ConversationPaneController extends Controller {
  connect() {
    this.scrollToAnchor()
  }

  async confirmArchive(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmArchive("this message")) {
      event.detail.resume(null)
    }
  }

  async confirmRecover(event: TurboBeforeFetchRequestEvent) {
    event.preventDefault()

    if (await Confirmation.confirmRecover("this message")) {
      event.detail.resume(null)
    }
  }

  private scrollToAnchor() {
    const hash = window.location.hash
    if (!hash) return

    // Small delay to ensure DOM is fully rendered
    requestAnimationFrame(() => {
      const targetElement = document.querySelector(hash)
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: "center" })
        // Add highlight effect - 500ms matches $duration-slow from design guide
        targetElement.classList.add("message-anchor-highlight")
        setTimeout(() => {
          targetElement.classList.remove("message-anchor-highlight")
        }, 500)
      }
    })
  }
}
